import React from 'react';

export class NotificationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Notification error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-sm text-red-600 p-2">
          Unable to load notifications
        </div>
      );
    }

    return this.props.children;
  }
}